import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Tabla } from '../models/tabla';

@Injectable({
  providedIn: 'root'
})
export class TablaService {
  private tablaCollection: AngularFirestoreCollection<Tabla>;

  constructor(private db: AngularFirestore) {
    this.tablaCollection = this.db.collection<Tabla>('tablas');
  }

  /**
   * GET ALL TASKS
   */
  getAllTablas(): Observable<DocumentChangeAction<Tabla>[]> {
    return this.tablaCollection.snapshotChanges();
  }

  /**
   * GET TASK BY ID
   * @param tablaId
   */
  getTabla(tablaId: string): Observable<Action<DocumentSnapshot<Tabla>>> {
    return this.tablaCollection.doc<Tabla>(tablaId).snapshotChanges();
  }

  /**
   * CREATE NEW TASK
   * @param newTabla
   */
  createTabla(newTabla: Tabla): Promise<DocumentReference> {
    return this.tablaCollection.add(newTabla);
  }

  /**
   * UPDATE SELECTED TASK
   * @param data
   * @param docId
   */
  updateTabla(data: Tabla, docId: string): Promise<void> {
    return this.tablaCollection.doc<Tabla>(docId).update(data);
  }

  /**
   * DELETE TASK
   * @param docId
   */
  deleteTabla(docId: string): Promise<void> {
    return this.tablaCollection.doc<Tabla>(docId).delete();
  }

  /**
 * GET ALL  TABLA USING idQuiniela
 */
   getAllTablasByIdQuiniela(idQuiniela: any): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('tablas', (ref) =>
      ref.where('idQuiniela', '==', idQuiniela)
    );
    return query.snapshotChanges()    
  }

    /**
* DELETE TABLA DE UNA QUINIELA POR SU ID
*/
deleteTablaByIdQuiniela(idQuiniela: any): void {
  let query = this.db.collection('tabla', ref => ref.where('idQuiniela', '==', idQuiniela));
  query.get().toPromise().then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      doc.ref.delete();
    });
  });
}
}
